var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "page-add-block" },
    [
      _c(
        "Tooltip",
        {
          attrs: { position: "bottom", show: _vm.showTooltip },
          on: { "tooltip-closed": _vm.onTooltipClosed }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$root.$emit(
                        "show::modal",
                        "quiz-type-select-modal"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "page-create-icon",
                    attrs: { src: "/static/images/ic-edit.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "typography--body-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("card_details.create_page")) +
                        "\n          "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.openPageLibraryModal }
                },
                [
                  _c("img", {
                    staticClass: "page-search-icon",
                    attrs: { src: "/static/images/ic-import.svg" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "typography--body-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("card_details.search_page")) +
                        "\n          "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "tooltip-body" }, slot: "tooltip-body" }, [
            _c("div", {
              staticClass: "typography--body-3 typography--color-secondary",
              domProps: {
                innerHTML: _vm._s(_vm.$t("common.tooltip.try_add_new_pages"))
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a24f08e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a24f08e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/PageAddBlock.vue
// module id = pZbv
// module chunks = 1